module.exports = __webpack_public_path__ + "static/rendition-downsized-example-022bf8ab9b6b9b99379e29f0149c7315.gif";